import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/video/MVP.mp4'


const _withScopeId = n => (_pushScopeId("data-v-29f91096"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "errorView"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-video wow-total animate__fadeInUp" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "text" }, "4"),
  /*#__PURE__*/_createElementVNode("video", {
    src: _imports_0,
    class: "video",
    loop: "",
    muted: "",
    autoplay: "",
    playsinline: ""
  }),
  /*#__PURE__*/_createElementVNode("b", { class: "text" }, "4")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "sub-text wow-total animate__fadeInUp" }, "Ooops page not found", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppLoader = _resolveComponent("AppLoader")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "bubble",
    mode: "out-in"
  }, {
    default: _withCtx(() => [
      (_ctx.loader)
        ? (_openBlock(), _createBlock(_component_AppLoader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            _createVNode(_component_router_link, {
              to: "/",
              class: "btn btn-blue wow-total animate__fadeInUp"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Go to main page")
              ]),
              _: 1
            })
          ]))
    ]),
    _: 1
  }))
}